import { ArrowRight, Layers3, Map, ShieldCheck } from 'lucide-react';
import ScrollReveal from './ScrollReveal';

const highlights = [
  {
    icon: Map,
    title: 'Sitemap-Driven Discovery',
    description: 'Discover URLs from sitemap and robots directives, then group by template patterns automatically.',
  },
  {
    icon: Layers3,
    title: 'Master Report + Child Reports',
    description: 'Run one domain-wide job and get an aggregated master report with drill-down links for every analyzed page.',
  },
  {
    icon: ShieldCheck,
    title: 'Background Pipeline',
    description: 'Approve once and let processing continue in the background with recovery, progress tracking, and completion email.',
  },
];

const DomainAnalysisHighlight = () => (
  <section className="py-12 md:py-14" aria-label="Domain Analysis highlight">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <div className="rounded-3xl border border-cv-sky/30 bg-cv-sky/10 p-6 sm:p-8 shadow-sm">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5 mb-6">
            <div>
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/80 border border-cv-sky/30 text-cv-navy text-xs font-bold uppercase tracking-wider mb-3">
                Unique Capability
              </span>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-cv-navy">
                Domain Analysis Built for Real Sites
              </h2>
              <p className="text-cv-navy/70 mt-2 max-w-3xl">
                Most tools score one page at a time. Crawler Vision analyzes domain structures with grouped planning, async processing, and a single decision-ready master report.
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <a
                href="/analyzer?mode=domain"
                className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-cv-navy hover:bg-cv-navy text-white font-semibold text-sm transition-colors"
              >
                Try Domain Analysis <ArrowRight className="w-4 h-4" />
              </a>
              <a
                href="/sample-dashboard.html"
                target="_blank"
                rel="noopener"
                className="inline-flex items-center gap-2 px-5 py-3 rounded-xl border border-cv-sky/50 bg-white text-cv-navy hover:bg-cv-sky/20 font-semibold text-sm transition-colors"
              >
                View Sample Dashboard
              </a>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-4">
            {highlights.map((item) => (
              <div key={item.title} className="rounded-2xl border border-white/70 bg-white/70 p-4">
                <item.icon className="w-5 h-5 text-cv-navy mb-2" />
                <h3 className="text-sm font-bold text-cv-navy mb-1">{item.title}</h3>
                <p className="text-sm text-cv-navy/70 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </ScrollReveal>
    </div>
  </section>
);

export default DomainAnalysisHighlight;
